// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.2 (commit 4b41cf3d71aa85cd4e75c96cbb54324481ee0b27).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
import { EnemyType } from "./enemy_type_type";
import { ProjectileInfo as __ProjectileInfo } from "./projectile_info_type";

import { type EventContext, type Reducer, RemoteReducers, RemoteTables } from ".";

/**
 * Table handle for the table `EnemyType`.
 *
 * Obtain a handle from the [`enemyType`] property on [`RemoteTables`],
 * like `ctx.db.enemyType`.
 *
 * Users are encouraged not to explicitly reference this type,
 * but to directly chain method calls,
 * like `ctx.db.enemyType.on_insert(...)`.
 */
export class EnemyTypeTableHandle {
  tableCache: TableCache<EnemyType>;

  constructor(tableCache: TableCache<EnemyType>) {
    this.tableCache = tableCache;
  }

  count(): number {
    return this.tableCache.count();
  }

  iter(): Iterable<EnemyType> {
    return this.tableCache.iter();
  }
  /**
   * Access to the `typeId` unique index on the table `EnemyType`,
   * which allows point queries on the field of the same name
   * via the [`EnemyTypeTypeIdUnique.find`] method.
   *
   * Users are encouraged not to explicitly reference this type,
   * but to directly chain method calls,
   * like `ctx.db.enemyType.typeId().find(...)`.
   *
   * Get a handle on the `typeId` unique index on the table `EnemyType`.
   */
  typeId = {
    // Find the subscribed row whose `typeId` column value is equal to `col_val`,
    // if such a row is present in the client cache.
    find: (col_val: number): EnemyType | undefined => {
      for (let row of this.tableCache.iter()) {
        if (deepEqual(row.typeId, col_val)) {
          return row;
        }
      }
    },
  };

  onInsert = (cb: (ctx: EventContext, row: EnemyType) => void) => {
    return this.tableCache.onInsert(cb);
  }

  removeOnInsert = (cb: (ctx: EventContext, row: EnemyType) => void) => {
    return this.tableCache.removeOnInsert(cb);
  }

  onDelete = (cb: (ctx: EventContext, row: EnemyType) => void) => {
    return this.tableCache.onDelete(cb);
  }

  removeOnDelete = (cb: (ctx: EventContext, row: EnemyType) => void) => {
    return this.tableCache.removeOnDelete(cb);
  }

  // Updates are only defined for tables with primary keys.
  onUpdate = (cb: (ctx: EventContext, oldRow: EnemyType, newRow: EnemyType) => void) => {
    return this.tableCache.onUpdate(cb);
  }

  removeOnUpdate = (cb: (ctx: EventContext, onRow: EnemyType, newRow: EnemyType) => void) => {
    return this.tableCache.removeOnUpdate(cb);
  }}
